/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React from 'react';
import {
    arrayOf,
    bool,
    func,
    number,
    oneOf,
    shape,
    string,
} from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import ProductFacetGroup from './ProductFacetGroup';

const useStyles = makeStyles(() => ({
    root: {
        width: '100%',
    },
    header: {
        position: 'sticky',
        top: 0,
        zIndex: 1,
        background: '#FFFFFF',
        padding: '20px 0px',
        borderBottom: '1px solid #D9D9D9',
    },
    searchPageHeader: {
        padding: '22px 0px !important',
    },
    title: {
        fontSize: '18px',
        fontWeight: 700,
        lineHeight: '24px',
        color: '#000000 !important',
    },
}));

const ProductFacetDesktop = ({
    title,
    productFacets,
    selectedProductFacets,
    onChange,
    itemType,
    loading,
    sortByOptions,
    selectedSortValue,
    onSortChange,
    sortByTitle,
    trackEvent,
    searchPage,
}) => {
    const classes = useStyles();

    const handleFacetChange = (facetName, value, checked, entry) => {
        onChange(facetName, value, checked, entry);
        if (checked) {
            trackEvent('Click', { name: entry.name, value, count: entry.count });
        }
    };

    return (
        <div className={classes.root}>
            <div className={`${classes.header}${searchPage ? ` ${classes.searchPageHeader}` : ''}`}>
                <Typography component="h2" className={classes.title}>{title}</Typography>
            </div>
            {sortByOptions?.length > 0 && (
                <ProductFacetGroup
                    facet={{
                        name: sortByTitle,
                        displayOpen: true,
                        entries: sortByOptions.map((option) => ({
                            name: option.label,
                            value: option.value,
                            count: 0,
                            from: null,
                            to: null,
                            tooltip: null,
                        })),
                    }}
                    selectedValues={[selectedSortValue]}
                    onChange={(_facetName, value, checked) => {
                        if (checked) {
                            trackEvent('Click', null, value);
                        }
                        onSortChange(checked ? value : '');
                    }}
                    itemType="radio"
                    loading={loading}
                />
            )}
            {productFacets.map((facet) => (
                <ProductFacetGroup
                    key={facet.name}
                    facet={facet}
                    selectedValues={selectedProductFacets}
                    onChange={handleFacetChange}
                    itemType={itemType}
                    loading={loading}
                />
            ))}
        </div>
    );
};

ProductFacetDesktop.propTypes = {
    title: string,
    productFacets: arrayOf(shape({
        name: string.isRequired,
        displayOpen: bool,
        entries: arrayOf(shape({
            name: string.isRequired,
            value: string.isRequired,
            count: number,
            from: number,
            to: number,
            tooltip: string,
        })),
    })).isRequired,
    selectedProductFacets: arrayOf(string),
    onChange: func,
    itemType: oneOf(['checkbox', 'radio']),
    loading: bool,
    sortByOptions: arrayOf(shape({
        label: string.isRequired,
        value: string.isRequired,
    })),
    selectedSortValue: string,
    onSortChange: func,
    sortByTitle: string,
    trackEvent: func,
    searchPage: bool,
};

ProductFacetDesktop.defaultProps = {
    title: 'Filter',
    selectedProductFacets: [],
    onChange: () => {},
    itemType: 'checkbox',
    loading: false,
    sortByOptions: [],
    selectedSortValue: '',
    onSortChange: () => {},
    sortByTitle: 'Sort by',
    trackEvent: () => {},
    searchPage: false,
};

export default ProductFacetDesktop;
